export default __webpack_public_path__ + "static/media/RUG-AVAX.b9f60e4d.svg";